import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { RetailPaymentsEmptyStateComponent } from '../empty-state/retail-payments-empty-state.component';

@Component({
  standalone: true,
  selector: 'smb-invoicing-retail-payments-onboarding',
  templateUrl: './retail-payments-onboarding.component.html',
  imports: [
    TranslateModule,
    NgIf,
    MatIconModule,
    MatButtonModule,
    GalaxyEmptyStateModule,
    RetailPaymentsEmptyStateComponent,
  ],
})
export class RetailPaymentsOnboardingComponent {
  @Input() isSupportedRegion: boolean;
  @Input() description: string;
  @Output() onboardingUnsupportedRegionClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() onboardingCallToActionClicked: EventEmitter<boolean> = new EventEmitter();
}
